import React from 'react'
import Fragment from '../common/fragment'


function FragmentAC(props) {
  return (
    <Fragment pos="c" {...props}>
      <p>
      Esa tarde todo parecía sereno: la plaza, la iglesia, la refinería, los trenes, Dios, su
Palabra, los transeúntes, el aire opaco, las chimeneas y sus fuegos perpetuos, los
predicadores y sus invocaciones otoñales. Era noviembre, pero pudo ser abril o
algún mes confuso del estío.
      </p>
    </Fragment>
  )
}


export default FragmentAC
